export { default as SeatModalitiesSection } from './seat-modalities-section.component'
